export const colorDarkBlue = "#06324a"
export const colorDarkRed = "#6A2733"
